export default __webpack_public_path__ + "static/media/two.94a81c95.jpeg";